// Grouping helpers for the two-way customer email thread model.
//
// An outbound CRM email and every reply it receives share a thread_id, so the
// inbox can present one row per conversation while the thread panel shows the
// whole exchange in order.

export function threadKey(log) {
  return (
    log?.thread_id ||
    log?.reference_code ||
    log?.message_id ||
    log?.from_address ||
    log?.customer_email ||
    log?.id
  );
}

export function isUnreadReply(log) {
  return log?.direction === 'inbound' && log?.inbox_status === 'new';
}

// One row per conversation — the most recent inbound reply represents it.
export function buildEmailConversations(logs = []) {
  const byThread = {};
  for (const log of logs) {
    if (log.direction !== 'inbound') continue;
    const key = threadKey(log);
    const current = byThread[key];
    if (!current || new Date(log.created_date) > new Date(current.created_date)) {
      byThread[key] = log;
    }
  }
  return Object.values(byThread).sort(
    (a, b) => new Date(b.created_date) - new Date(a.created_date)
  );
}

export function threadMessages(logs = [], key) {
  return logs
    .filter((l) => threadKey(l) === key)
    .sort((a, b) => new Date(a.created_date) - new Date(b.created_date));
}

export function threadHasUnread(logs = [], key) {
  return logs.some((l) => threadKey(l) === key && isUnreadReply(l));
}